import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { setupGatewayAlarmService } from './utils/gatewayAlarmService'
import { transientMessage, resetSessionFeedback } from './utils/messages'
const { createScopedMessages } = require('./utils/transientMessages.cjs')

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false
Vue.use(ElementUI);
// Async handlers belonging to a disposed page or previous login must not
// display errors over the current account, including component catch blocks.
Vue.mixin({
  beforeCreate() {
    this._sessionMessages = createScopedMessages(transientMessage, () => !this._isDestroyed && !this._isBeingDestroyed)
  }
})
Object.defineProperty(Vue.prototype, '$message', {
  configurable: true,
  get() { return this._sessionMessages || transientMessage }
})
window.addEventListener('storage', event => {
  if (event.key === 'username' || (event.key === 'token' && !event.newValue)) resetSessionFeedback()
})

setupGatewayAlarmService(router, store)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
